import JobTaskList from './pages/ListPage.vue'
import JobTaskDetail from './pages/FormPage.vue'
import JobTaskIndex from './pages/IndexPage.vue'

export default [
  {
    path: '/job_task',
    component: JobTaskIndex,
    redirect: '/job_task/list',
    name: 'job_task',
    children: [
      {
        path: 'list',
        component: JobTaskList,
        name: 'job_task.list'
      },
      {
        path: 'create',
        component: JobTaskDetail,
        name: 'job_task.create',
        props: {create: true},
      },
      {
        path: 'edit/:id',
        component: JobTaskDetail,
        name: 'job_task.edit',
        props: {create: false},
      },
    ],
  },
]
